import type React from "react"
import { useState } from "react"
import "./form-ui.css"
import SearchIcon from "../../assets/svgs/SearchIcon"

const SearchFilterInput = ({ placeholder, searchTerm, handleSearch, extraClass = '' }) => {
  return (
    <form className={`search-form ${extraClass}`}>
      <div className="search-input-container">
        <SearchIcon />
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={searchTerm || ''}
          onChange={handleSearch}
        />
      </div>
    </form>
  );
};

export default SearchFilterInput;
